import React from "react";
import PropTypes from "prop-types";
import withTranslation from "../translation";
import styles from "./LegalBar.css";
import { SMALL_VIEWPORT } from "@template/state/modules/layout/constants";

const LegalBar = ({
  formatTranslation,
  defaultStoreUrl,
  countryCode,
  viewport
}) => (
  <div className={styles.container}>
    <div className={styles.body} data-testid="legalbar">
      <p className={styles.copyright}>© {new Date().getFullYear()} ASOS</p>
      <ul className={styles.links}>
        {countryCode === "DE" && (
          <li>
            <a
              className={styles.asosFocus}
              href={defaultStoreUrl.concat(
                formatTranslation("legalbar_imprint_link")
              )}
            >
              {formatTranslation("legalbar_imprint")}
            </a>
          </li>
        )}
        <li>
          <a
            className={styles.asosFocus}
            href={defaultStoreUrl.concat(
              formatTranslation("legalbar_privacy_link")
            )}
          >
            {countryCode === "DE" && viewport === SMALL_VIEWPORT
              ? formatTranslation("legalbar_privacy_abridged")
              : formatTranslation("legalbar_privacy")}
          </a>
        </li>
        <li>
          <a
            className={styles.asosFocus}
            href={defaultStoreUrl.concat(
              formatTranslation("legalbar_terms_link")
            )}
          >
            {formatTranslation("legalbar_terms")}
          </a>
        </li>
        <li className={styles.hideOnSmallViewport}>
          <a
            className={styles.asosFocus}
            href={defaultStoreUrl.concat(
              formatTranslation("legalbar_accessibility_link")
            )}
          >
            {formatTranslation("legalbar_accessibility")}
          </a>
        </li>
      </ul>
    </div>
  </div>
);

LegalBar.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  defaultStoreUrl: PropTypes.string.isRequired,
  countryCode: PropTypes.string.isRequired,
  viewport: PropTypes.string.isRequired
};

export default withTranslation(LegalBar);
